import { useStyles } from "@b2bportal/core-themes";
import { type ApacUiComponent, APAC_UI_NAME } from "@apac/components/ui";

export const useApacUiStyles = (
  componentName: keyof typeof ApacUiComponent,
  defaultStyles?: object
) => {
  return useStyles(APAC_UI_NAME, componentName, defaultStyles);
};
